export default [
    {
        icon: 'ni ni-ui-04',
        action: 'edit',
        title: 'Редактировать',
        color: '#0000cc',
        method: 'goToItem',
    },
];
